import React from 'react';
import classNames from 'classnames';
import classnames from './all-product-images.module.scss';
export const AllProductImages = ({
  images,
  activeImage,
  onChangeView
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames.container
  }, images.map(image => /*#__PURE__*/React.createElement("img", {
    key: image.url,
    src: image.url,
    alt: `${image.id} variant`,
    onClick: () => onChangeView(image.id),
    className: classNames(classnames.image, {
      [classnames.activeImage]: activeImage.url === image.url
    })
  })));
};